import { CLOSE_STATUS_BAR, SHOW_STATUS_BAR } from '../constants/actions';

export const closeStatusBar = () => {
  return { type: CLOSE_STATUS_BAR };
};

export const showStatusBar = ({ message, title, actionButtonValue }) => {
  return {
    type: SHOW_STATUS_BAR,
    actionButtonValue,
    message,
    title,
  };
};
